import React from "react";
import { bool, func, object, oneOfType, string } from "prop-types";

import TitleContainer from "../Title";
import AddressTextField from "../../shared/AddressTextField";

import { addressType } from "@types";

const TitleSection = ({
  typesContainerRef,
  setIsTypeExplanationOpen,
  shouldRenderAddress,
  address,
  onResetAddress,
  onSetAddress,
}) => (
  <div className="p-4 lg:px-8">
    <TitleContainer
      setIsTypeExplanationOpen={setIsTypeExplanationOpen}
      typesContainerRef={typesContainerRef}
    />
    {shouldRenderAddress && (
      <AddressTextField
        initialValue={address}
        onResetAddress={onResetAddress}
        onSetAddress={onSetAddress}
      />
    )}
  </div>
);

TitleSection.propTypes = {
  typesContainerRef: object.isRequired,
  setIsTypeExplanationOpen: func.isRequired,
  shouldRenderAddress: bool.isRequired,
  address: oneOfType([addressType, string]),
  onResetAddress: func.isRequired,
  onSetAddress: func.isRequired,
};

export default TitleSection;
